import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
//import Model from '../views/Model.vue'
//import Help from "../views/Help";

Vue.use(VueRouter);

const routes = [
    // Einstieg (Ladebildschirm)
    {
        path: '/',
        component: Home,
        meta: {
            title: 'Start'
        }
    },
   
    // 010 - finnisches endlager
    {
        path: '/010_FinnischesEndlager.vue',
        component: () => import(/* webpackChunkName: "animation" */ '../views/010_FinnischesEndlager.vue')
    },

    // 020 - deutsches endlager
    {
        path: '/020_DeutschesEndlager',
        component: () => import(/* webpackChunkName: "animation" */ '../views/020_DeutschesEndlager.vue')
    },

    // 030 - aufzug
    {
        path: '/030_Aufzug',
        component: () => import(/* webpackChunkName: "animation" */ '../views/030_Aufzug.vue')
    },

    // 040 - schaechte
    {
        path: '/040_Schaechte',
        component: () => import(/* webpackChunkName: "animation" */ '../views/040_Schaechte.vue')
    },

    // 050 - gesteinsarten
    {
        path: '/050_Gesteinsarten',
        component: () => import(/* webpackChunkName: "animation" */ '../views/050_Gesteinsarten.vue')
    },

    // 060 - strahlung
    {
        path: '/060_Strahlung',
        component: () => import(/* webpackChunkName: "animation" */ '../views/060_Strahlung.vue')
    },

    // 070 - fuellung
    {
        path: '/070_Fuellung',
        component: () => import(/* webpackChunkName: "animation" */ '../views/070_Fuellung.vue')
    },

    // 080 - karte teilgebiete
    {
        path: '/080_KarteTeilgebiete',
        component: () => import(/* webpackChunkName: "animation" */ '../views/080_KarteTeilgebiete.vue')
    },

    // 090 - teilgebiete in deutschland
    {
        path: '/090_Teilgebiete',
        component: () => import(/* webpackChunkName: "animation" */ '../views/090_Teilgebiete.vue')
    },

    // Credits
    {
        path: '/Credits',
        component: () => import(/* webpackChunkName: "credits" */ '../views/Credits.vue'),
        meta: {
            title: 'Credits'
        }
    },
   
];

const router = new VueRouter({
    // mode: abstract, history, hash
    mode: process.env.VUE_APP_ROUTER_MODE ? process.env.VUE_APP_ROUTER_MODE : 'abstract',
    base: process.env.BASE_URL,
    routes
});

export default router
